module.exports = __webpack_public_path__ + "04_medium_black.81e405d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_medium_black.png
// module id = KmLR
// module chunks = 0